import React, { useState, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { connect } from 'react-redux';

import { Pulldown } from 'jbc-front/components/icons';
import Loading from 'src/components/Loading';
import { STATUSCOLORS } from 'src/constants/Colors';
import { fetchTotalEmployee, getChartData, setDashboardData } from 'src/reducers/dashboard';
import { convertMonthNumberToStr } from 'src/utils/Dashboard';

import BoxComponent from './BoxComponent';
import { Title, TitleBar, Row, Box, Current, ToggleSection, Toggle, ToggleButton, Button, Month, Link, Container, CollapseWrap } from '../styles/TotalEmployee';

const TotalEmployee = ({ numberEmployees, setChart, fetchTotalEmployeeData, totalEmployees }) => {
  const latestMonth = moment(numberEmployees.date)?.month() + 1;
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(latestMonth || 0);
  const [display, setDisplay] = useState('none');

  const { t } = useTranslation();

  useEffect(() => {
    setChart('totalEmployee', numberEmployees);
  }, []);

  const month = convertMonthNumberToStr(selectedMonth);

  // switch toggle display
  const toggleClick = () => {
    if (display === 'none') setDisplay('flex');
    else setDisplay('none');
  };

  // on Change Month
  const handleChangeMonth = async value => {
    if (value < 1 || value > latestMonth) return;
    setIsLoading(true);
    await fetchTotalEmployeeData(value);
    setSelectedMonth(value);
    setIsLoading(false);
  };

  return (
    <div className="u-mt30">
      <Container>
        <Current>
          <TitleBar>
            <Button
              className="previous"
              id="prevButton"
              onClick={() => {
                handleChangeMonth(selectedMonth - 1);
              }}
              disabled={selectedMonth === 1}
            >
              <Pulldown size={10} />
            </Button>

            <Title>
              <label id="label">{t(`features.Dashbord.components.TotalEmployee.Title`)} </label>
              <Month id="month">{t(`features.Dashbord.components.TotalEmployee.Month.${month}`)}</Month>
            </Title>

            <Button
              className="next"
              id="nextButton"
              onClick={() => {
                handleChangeMonth(selectedMonth + 1);
              }}
              disabled={selectedMonth === latestMonth}
            >
              <Pulldown size={10} />
            </Button>
          </TitleBar>
          {isLoading ? (
            <Loading />
          ) : (
            <>
              <ThemeProvider theme={{ font: '20px' }}>
                <Box>
                  {month === 'ThisMonth' ? (
                    <Link href={totalEmployees.data?.activeLink} target="_blank" id="activeLink">
                      <BoxComponent
                        bg={STATUSCOLORS.ACTIVE[1]}
                        color={STATUSCOLORS.ACTIVE[0]}
                        amount={totalEmployees.data?.active}
                        label={t(`features.Dashbord.components.TotalEmployee.Active`)}
                        id="active"
                      />
                    </Link>
                  ) : (
                    <BoxComponent
                      bg={STATUSCOLORS.ACTIVE[1]}
                      color={STATUSCOLORS.ACTIVE[0]}
                      amount={totalEmployees.data?.active}
                      label={t(`features.Dashbord.components.TotalEmployee.Active`)}
                      id="active"
                    />
                  )}
                </Box>
              </ThemeProvider>
              <Row>
                <ThemeProvider theme={{ flex: '50%', font: '20px' }}>
                  <Box>
                    {month === 'ThisMonth' ? (
                      <Link href={totalEmployees.data?.joinedLink} target="_blank" id="joinedLink">
                        <BoxComponent
                          bg={STATUSCOLORS.JOINED[1]}
                          color={STATUSCOLORS.JOINED[0]}
                          amount={totalEmployees.data?.joined}
                          label={t(`features.Dashbord.components.TotalEmployee.Joined`)}
                          id="joined"
                        />
                      </Link>
                    ) : (
                      <BoxComponent
                        bg={STATUSCOLORS.JOINED[1]}
                        color={STATUSCOLORS.JOINED[0]}
                        amount={totalEmployees.data?.joined}
                        label={t(`features.Dashbord.components.TotalEmployee.Joined`)}
                        id="joined"
                      />
                    )}
                  </Box>
                  <Box>
                    {month === 'ThisMonth' ? (
                      <Link href={totalEmployees.data?.resignedLink} target="_blank" id="resignedLink">
                        <BoxComponent
                          bg={STATUSCOLORS.RESIGNED[1]}
                          color={STATUSCOLORS.RESIGNED[0]}
                          amount={totalEmployees.data?.resigned}
                          label={t(`features.Dashbord.components.TotalEmployee.Resigned`)}
                          id="resigned"
                        />
                      </Link>
                    ) : (
                      <BoxComponent
                        bg={STATUSCOLORS.RESIGNED[1]}
                        color={STATUSCOLORS.RESIGNED[0]}
                        amount={totalEmployees.data?.resigned}
                        l
                        label={t(`features.Dashbord.components.TotalEmployee.Resigned`)}
                        id="resigned"
                      />
                    )}
                  </Box>
                </ThemeProvider>
              </Row>
            </>
          )}
        </Current>

        <CollapseWrap>
          <ThemeProvider theme={{ display, month }}>
            <ToggleSection id={`toggleSection-${month === 'ThisMonth' ? 'enabled' : 'disabled'}`}>
              <Box>
                <Link href={totalEmployees.data?.incomingLink} target="_blank" id="incomingLink">
                  <BoxComponent
                    bg={STATUSCOLORS.INCOMING[1]}
                    color={STATUSCOLORS.INCOMING[0]}
                    amount={totalEmployees.data?.incoming}
                    label={t(`features.Dashbord.components.TotalEmployee.InComing`)}
                    ft={'14px'}
                    padding={'5px'}
                    id="incoming"
                  />
                </Link>
              </Box>
              <Box>
                <Link href={totalEmployees.data?.resigningLink} target="_blank" id="resigningLink">
                  <BoxComponent
                    bg={STATUSCOLORS.RESIGNING[1]}
                    color={STATUSCOLORS.RESIGNING[0]}
                    amount={totalEmployees.data?.resigning}
                    label={t(`features.Dashbord.components.TotalEmployee.Resigning`)}
                    ft={'14px'}
                    padding={'5px'}
                    id="resigning"
                  />
                </Link>
              </Box>
              <Box>
                <Link href={totalEmployees.data?.onLeaveLink} target="_blank" id="onLeaveLink">
                  <BoxComponent
                    bg={STATUSCOLORS.ONLEAVE[1]}
                    color={STATUSCOLORS.ONLEAVE[0]}
                    amount={totalEmployees.data?.onLeave}
                    label={t(`features.Dashbord.components.TotalEmployee.OnLeave`)}
                    ft={'14px'}
                    padding={'5px'}
                    id="onleave"
                  />
                </Link>
              </Box>
            </ToggleSection>
          </ThemeProvider>
        </CollapseWrap>
      </Container>
      <ThemeProvider theme={{ month }}>
        <Toggle>
          <ToggleButton id="toggleButton" onClick={toggleClick}>
            {display === 'none' ? t(`features.Dashbord.components.TotalEmployee.ShowMore`) : t(`features.Dashbord.components.TotalEmployee.ShowLess`)}
          </ToggleButton>
        </Toggle>
      </ThemeProvider>
    </div>
  );
};

const mapStateToProps = state => ({
  totalEmployees: getChartData(state, 'totalEmployee')
});

const mapDispatchToProps = dispatch => ({
  fetchTotalEmployeeData: data => dispatch(fetchTotalEmployee(data)),
  setChart: (key, object) => dispatch(setDashboardData(key, object))
});

export default connect(mapStateToProps, mapDispatchToProps)(TotalEmployee);
